const PROFILE = {
  name: 'Krish Satasiya',
  role: 'Full Stack Developer & Product Designer',
  education: 'B.Tech (CE) | Silver Oak University (8.81 CGPA)',
  location: 'Ahmedabad, Gujarat, India',
  email: 'krishsatasiya44@gmail.com',
  phone: '+91 6353112999',
  socials: {
    github: 'https://github.com/satasiyakrish1',
    linkedin: 'https://linkedin.com/in/satasiyakrish1',
    twitter: 'https://twitter.com/satasiyakrish1',
    portfolio: 'https://krishsatasiya.netlify.app/',
  },
  stack: [
    'React & Next.js', 'Node.js & Express', 'TypeScript', 'PostgreSQL', 
    'MongoDB', 'Tailwind CSS', 'Figma & UI/UX', 'React Native', 
    'AWS & Cloud', 'Docker', 'GraphQL', 'CI/CD & DevOps'
  ],
  bio: `Building clarity where others add complexity. I help businesses design, build, and scale digital products with the right technology — whatever your stage or vision.`,
  tools: [
    'Figma', 'Adobe Illustrator', 'Adobe AfterEffects', 'Blender', 'Sketchup', 'WordPress', 'Shopify',
    'VS Code', 'Git/GitHub', 'Docker', 'GCP & AWS', 'Firebase', 'Postgres & SQL', 'Jenkins CI/CD', 'Vercel', 'Netlify'
  ],
  languages: ['English', 'Hindi', 'Gujarati'],
  goal: 'Motivated and creative Full Stack Developer adept at delivering performance-optimized web applications with seamless user experience.',
  stats: [
    { val: '1st', label: 'RedHat India Winner Compition' },
    { val: '8.81', label: 'B.Tech CGPA' },
    { val: '35%', label: 'Engagement Boost' },
    { val: '93.9%', label: 'Project Uptime' },
  ],
};

export default PROFILE;
